/* eslint-disable no-plusplus */
/* eslint-disable react/prop-types */
import React from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import "./style/style.css";

function Gallery({ imageProperty }) {
  // get image url
  const imageUrl = imageProperty?.map((image) => image.image_property);
  const getPics = (data) => {
    const vals = [];
    for (let i = 0; i < data?.length; i++) {
      vals.push({
        original: `${data[i]}`,
        thumbnail: `${data[i]}`,
      });
    }
    return vals;
  };
  const images = getPics(imageUrl);
  return <ImageGallery items={images} width="500px" />;
}

export default Gallery;
